import { Navigate } from "react-router-dom";
import { WeldTestPage } from "../../pages/weld-test";
import { WeldTestsManagerPage } from "../../pages/weld-test/manager/WeldTestsManagerPage";

export const routeWeldTest = "/weld-test";
export const routeWeldTestsManager = "/weld-test/manager";

export const weldTestRoutes = [
	{
		path: routeWeldTest,
		element: <WeldTestPage />,
	},
	{
		path: routeWeldTestsManager,
		element: <WeldTestsManagerPage />,
	},
	// Old bookmarked URL
	{
		path: "/weld-test/report",
		element: <Navigate to={routeWeldTestsManager} replace />,
	},
];
